import React from "react";
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        return this.state.hasError
            ? React.createElement(React.Fragment, null)
            : this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map